import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FONT_FAMILY_MAP, resolveConditionalColor } from '../utils';
import { useTranslation } from 'react-i18next';

const HeatMapChartComponent = ({ widget, stats }) => {
  const { t } = useTranslation();

  const tableStyle = { borderCollapse: 'collapse', width: '100%' };
  const cellStyle = { border: '1px solid #ccc', padding: '8px', textAlign: 'center' };

  const { advancedProps = {} } = widget;

  const valueFontFamily = FONT_FAMILY_MAP[advancedProps.formattingFontWeight] || '';

  const data = useMemo(() => stats ?? [], [stats]);
  const { dates, sets, matrix } = useMemo(() => {
    const dates = [];
    const sets = [];

    data.forEach(({ xaxis, yaxis }) => {
      if (!dates.includes(xaxis)) dates.push(xaxis);
      if (!sets.includes(yaxis)) sets.push(yaxis);
    });

    const matrix = Array.from({ length: sets.length }, () => Array(dates.length).fill(0));

    data.forEach(({ xaxis, yaxis, value }) => {
      const row = sets.indexOf(yaxis);
      const col = dates.indexOf(xaxis);
      matrix[row][col] = value;
    });

    return { dates, sets, matrix };
  }, [data]);

  return !stats ? (
    <div>{t('text_loading_chart_data')}</div>
  ) : data.length === 0 ? (
    <div>No data to show</div>
  ) : (
    <div className='d-flex flex-column align-items-center'>
      <div>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={cellStyle}>Set / Date</th>
              {dates.map((date) => (
                <th key={date} style={cellStyle}>
                  {date}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {sets.map((set, rowIdx) => (
              <tr key={set}>
                <td style={cellStyle}>{set}</td>
                {matrix[rowIdx].map((value, colIdx) => (
                  <td
                    key={colIdx}
                    style={{
                      ...cellStyle,
                      backgroundColor: resolveConditionalColor(value, advancedProps, '#ffffff'),
                      fontSize: advancedProps.formattingFontSize,
                      fontFamily: valueFontFamily,
                    }}
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

HeatMapChartComponent.propTypes = {
  widget: PropTypes.object.isRequired,
  stats: PropTypes.array,
};

export default HeatMapChartComponent;
